import dayjs from "dayjs";
import { localizeByKeyStatic } from "components/service";

export const COMMUNICATION_DATE_FORMAT = "DD.MM.YYYY";
export const COMMUNICATION_DATE_TIME_FORMAT = "DD.MM.YYYY, HH:mm:ss";
export const COMMUNICATION_DATE_TIME_SHORT_FORMAT = "DD.MM.YYYY, HH:mm";

const toCommunicationDayjs = (value?: string | Date | null) => {
  if (!value) {
    return undefined;
  }

  const parsedValue = dayjs(value);
  return parsedValue.isValid() ? parsedValue : undefined;
};

export const formatCommunicationDate = (value?: string | Date | null): string =>
  toCommunicationDayjs(value)?.format(COMMUNICATION_DATE_FORMAT) || "";

export const formatCommunicationDateTime = (value?: string | Date | null): string =>
  toCommunicationDayjs(value)?.format(COMMUNICATION_DATE_TIME_FORMAT) || "";

export const formatCommunicationDateTimeShort = (value?: string | Date | null): string =>
  toCommunicationDayjs(value)?.format(COMMUNICATION_DATE_TIME_SHORT_FORMAT) || "";

export const formatRelativeCommunicationDate = (value?: string | Date | null): string => {
  const d = toCommunicationDayjs(value);
  if (!d) return "";
  const now = dayjs();
  const diffMin = now.diff(d, "minute");
  if (diffMin < 1) return localizeByKeyStatic("COMMUNICATION.Relative_JustNow");
  if (diffMin < 60) return localizeByKeyStatic("COMMUNICATION.Relative_MinutesAgo", { count: diffMin });
  const diffH = now.diff(d, "hour");
  if (diffH < 24) return localizeByKeyStatic("COMMUNICATION.Relative_HoursAgo", { count: diffH });
  if (now.isSame(d, "day")) return localizeByKeyStatic("COMMUNICATION.Relative_Today");
  if (now.subtract(1, "day").isSame(d, "day")) return localizeByKeyStatic("COMMUNICATION.Relative_Yesterday");
  if (now.diff(d, "day") < 7) return d.format("ddd");
  return d.format("D MMM");
};

export const getCommunicationDayKey = (value?: string | Date | null): string => {
  const parsedValue = value ? toCommunicationDayjs(value) : dayjs();

  if (!parsedValue || !parsedValue.isValid()) {
    return "";
  }

  return parsedValue.format("YYYY-MM-DD");
};
